export default __webpack_public_path__ + "static/media/action-cancel-icon.04f10686.svg";